import React, { Component, useEffect, useState } from 'react';
import { ThemeProvider } from '@mui/styles';
import login_navender_logo from '../images/navender_logo.png';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common';
import Swal from "sweetalert2";
const apiUrl = RUN_TIME_API_ENDPOINT;

const ForgotPassword = (props) => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState(false);
    const [validFields, setValidFields] = useState(false);
    const [accessBlocked, setAccessBlocked] = useState(false);
    const [unauthorized, setUnauthorized] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [resMessage, setResMessage] = useState('');
    const [notValidUser, setNotValidUser] = useState(false);
    const [checkFields, setCheckFields] = useState('');

    const validateFields = (email) => {
        console.log('inside validateFields');
        let validFields = false;
        let emailError = false
        const emailRegex = RegExp(
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
          );
          console.log('asaasa===>', emailRegex.test(email))
        if (!email || !emailRegex.test(email)) {
            console.log('email inside validateFields===>', email);
            validFields = false;
            emailError = true;
        } else if (email) {
            validFields = true;
            emailError = false;
        }
        // this.setState({
        //     validFields,
        //     emailError,
        //     passwordError,
        // }, () => this.state.validFields)
        return { validFields, emailError }
    }

    const submit = (e) => {
        // console.log('email inside submit=====>', state.email);
        // console.log('pwd inside submit=====>', state.password);
        console.log('inside submit===>');
        let url = "";
        e.preventDefault();
        const checkFields = validateFields(email);
        setCheckFields({...checkFields, notValidUser: false})
        // this.setState({
        //     ...checkFields,
        //     notValidUser: false,
        // });
        if (checkFields.validFields) {
            setShowLoader(true);
            // this.setState({
            //     showLoader : true,
            // })
            url = `${apiUrl}/forgot-password`;
            const options = CommonHeaderOption();
            options.method = 'POST';
            options.headers = {
                // 'authorization': tokenId,
                'Content-Type': 'application/json'
            };
            options.body = JSON.stringify({ email: email });
            return fetch(url, options)
                .then(res => {
                    console.log('res inside new login===>', res);
                    console.log('no okkay //////', unauthorized, accessBlocked);
                    if (res.status == 403) {
                        setResMessage(res.message);
                        setAccessBlocked(true);
                        setUnauthorized(false);
                        setShowLoader(false);
                        // this.setState({
                        //     resMessage: res.message,
                        //     accessBlocked: true,
                        //     unauthorized: false,
                        //     showLoader: false,
                        // });
                        // throw new Error(res.statusText);
                    } else if (res.status == 401) {
                        setResMessage(res.message);
                        setAccessBlocked(false);
                        setUnauthorized(true);
                        setShowLoader(false);
                        // this.setState({
                        //     resMessage: res.message,
                        //     unauthorized: true,
                        //     accessBlocked: false,
                        //     showLoader: false,
                        // });
                    } else if(res.status == 404 || res.status == '404') {
                        setResMessage(res.message);
                        setAccessBlocked(false);
                        setUnauthorized(false);
                        setShowLoader(false);
                        setNotValidUser(true);

                        // this.setState({
                        //     resMessage: res.message,
                        //     notValidUser: true,
                        //     unauthorized: false,
                        //     accessBlocked: false,
                        //     showLoader: false,
                        // });
                    }
                    else {
                        setResMessage(res.message);
                        setAccessBlocked(false);
                        setUnauthorized(false);
                        setShowLoader(false);
                        // this.setState({
                        //     resMessage: res.message,
                        //     unauthorized: false,
                        //     accessBlocked: false,
                        //     showLoader: false,
                        // });
                    }
                    console.log('okkay //////', unauthorized, accessBlocked);
                    return res.json();
                })
                .then((resp) => {
                    // console.log('our use ', resp);
                    if (resp.status === 'success') {
                        console.log('===>', resp);
                        setShowLoader(false);
                        setShowMessage(true);
                        setResMessage(resp.message);
                        // this.setState({
                        //     showLoader:false,
                        //     showMessage: true,
                        //     resMessage: resp.message
                        // })
                        Swal.fire({
                            text: resp.message,
                            confirmButtonText: `OK`,
                            icon: "success",
                          }).then((data) =>
                          props.history.push({
                            pathname: "/login",
                          })
                        );
                        // setTimeout(() => {
                        //     window.location.href = "/#";
                        // },2500)
                    }
                }).catch(error => {
                    setShowLoader(false);
                    // this.setState({ showLoader:false});
                    Swal.fire({
                        text: 'Failed to send link',
                        confirmButtonText: `OK`,
                        icon: "error",
                      })
                    console.log(error);
                });
        }
    }

    const handleEmail = (e) => {
        const emailRegex = RegExp(
            /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
          );
        emailRegex.test(e.target.value) ? setEmailError(false) : setEmailError(true);
        setEmail(e.target.value);
        setShowLoader(false);
        // this.setState({
        //     email: e.target.value,
        //     showLoader: false,
        // });

    }

        return (
            <React.Fragment>
                <ThemeProvider theme={props.theme}>
                    <div className="email-login-page">
                        <div>
                            <img src={login_navender_logo} />
                        </div>
                        <div className="email-login-form">
                            <form onSubmit={submit}>
                                <div>
                                    <label for="fname">Email  <sup className="asterisk">*</sup></label>
                                    <input
                                        name="email"
                                        type="email"
                                        value={email}
                                        onChange={handleEmail}
                                    />
                                    {emailError &&
                                        <div className="email-login-error" >
                                            {'Invalid Email'}</div>
                                    }
                                </div>
                                <div>
                                    <button disabled={email === '' || showLoader || emailError} className="email-login-button" type="submit">{'Send Link'}</button>
                                </div>
                                {unauthorized &&
                                    <div className="email-login-error-centered" >
                                        {'Unauthorized User'}</div>
                                }
                                {accessBlocked &&
                                    <div className="email-login-error-centered" >
                                        {'Access temporarily blocked due to security reasons. Please try again after 1 hour.'}</div>
                                }
                                {showLoader && !unauthorized && !accessBlocked &&
                                    <div className="login-loader" />
                                }
                                {
                                    showMessage &&
                                    <div>{resMessage}</div>
                                }
                                {
                                    notValidUser &&
                                    <div className="email-login-error-centered" >
                                        {'Email address not found. Please check and try again.'}</div>
                                }
                            </form>
                        </div>
                    </div>
                </ThemeProvider>
            </React.Fragment>
        );
};
export default ForgotPassword;
